export default function SectionHeading({ kicker, title, subtitle, light = false, center = false }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} mb-10 md:mb-14`}>
      {kicker && (
        <p
          className={`font-accent text-sm uppercase tracking-[0.25em] mb-3 ${
            light ? "text-cream/70" : "text-rust"
          }`}
        >
          {kicker}
        </p>
      )}
      <h2
        className={`font-heading text-4xl sm:text-5xl uppercase leading-[0.95] ${
          light ? "text-cream" : "text-charcoal"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base leading-relaxed ${light ? "text-cream/80" : "text-charcoal/70"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
